import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OrcaPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    useEffect(() => {
        ctxView.setCustomPageConfig({
            markerDetailStyle: 'Mini'
        });
    }, []);

    return (
        <S_OrcaPage className={props.className}>
            <CustomMapPage mapId={'56446334-c737-4aab-992d-e1a91a045256'} highlightedStyle={''} />
        </S_OrcaPage>
    );
};

const S_OrcaPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
